<template>
    <div class="stdenis-signup">
        <form role="form">
            <div class="container-fluid">
                <div class="row align-content-md-center">
                    <div class="col-lg-6 col-md-5 offset-lg-3 signup-container">
                        <div class="card">
                            <div class="card-body">
                                <blockquote class="blockquote mb-0">
                                    <h5 class="card-title">Are you registering as a Family or an Individual ?</h5>
                                    <div class="form-check form-check-inline">
                                        <label class="input-mask" :class="[active_radio?'active':'']" @click="toggle_input('individual')">
                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="individual">
                                        </label>
                                        <label class="form-check-label" for="individual">individual</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                         <label class="input-mask" :class="[active_radio?'':'active']" @click="toggle_input('family')">
                                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="family">
                                        </label>
                                        <label class="form-check-label" for="family">family</label>
                                    </div>
                                    <a href="#" class="btn stdenis-btn-outline m-4 pull-right" @click.prevent="switchComponent">Proceed&nbsp;<i class="icon ion-md-arrow-dropright"></i> </a>
                                    <hr>
                                    <footer class="blockquote-footer text-right">St. Denis Akoka</footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "SignUp",
        mounted() {
            //Scroll to Top Positon
            window.scrollTo(0, 0);
        },
        data(){
            return{
                active_radio: true,
            }
        },
        methods:{
            toggle_input: function(value){
                switch (value) {
                    case 'individual':
                        this.active_radio = true;
                        break;
                    case 'family':
                        this.active_radio = false;
                        break
                }
            },
            switchComponent: function(){
                if(this.active_radio === true){
                    this.$router.push({name: 'IndividualSignup'});
                }else{
                    this.$router.push({name: 'FamilySignup'});
                }
            }
        }
    }
</script>

<style scoped>
    .stdenis-signup{
        padding: 60px 0;
    }
    .input-mask{
        width:20px;
        height:20px;
        background-color: rgb(200,200,200);
        margin-right:10px;
        border-radius: 5px;
    }
    .input-mask:hover{
        cursor: pointer;
    }
    .input-mask.active{
        background-color: #E12993;
    }
    .input-mask > input{
        visibility: hidden;
        position: absolute;
        width:100%;
        height:100%;
        top:0;
        left:0
    }

</style>